import 'whatwg-fetch';
import React from 'react';
import * as Sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';

import config from 'config/site.config';

import AppWrapper from './appWrapper';
import { initI18n } from './i18n';
import { getUserManager } from './libs/auth';
import { initOidcState } from './libs/authState';
import { addCustomValidationRules } from './libs/formFunctions';

addCustomValidationRules();
const isContainedEnvironment =
  import.meta.env.VITE_CONTAINED_ENVIRONMENT === 'true';
/*
  Init Sentry
 */
if (!isContainedEnvironment && import.meta.env.VITE_IS_ON_SERVER === 'true') {
  Sentry.init({
    dsn: config.sentry.dsn,
    environment: import.meta.env.VITE_NODE_ENV,
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
  });
}

const tagManagerArgs = {
  gtmId: 'GTM-K2BKZ55',
};

if (
  import.meta.env.VITE_NODE_ENV === 'production' &&
  import.meta.env.VITE_IS_ON_SERVER !== 'true'
) {
  tagManagerArgs.auth = 'RrseJifR84Opks_fwjm6YA';
  tagManagerArgs.preview = 'env-6';
} else {
  tagManagerArgs.auth = 'pNlh_OlDpT2YEOU0mbAEGQ';
  tagManagerArgs.preview = 'env-1';
}

if (!isContainedEnvironment && config.mixpanelToken) {
  mixpanel.init(config.mixpanelToken, {
    api_host: 'https://api-eu.mixpanel.com',
    debug: false,
    track_pageview: false,
    persistence: 'localStorage',
  });
}

if (isContainedEnvironment) {
  window.dataLayer = window.dataLayer || [];
} else {
  TagManager.initialize(tagManagerArgs);
}

/*
  Load and init translations
*/
(async () => {
  await initI18n();

  /*
    oidc state init
  */
  initOidcState(getUserManager());

  createRoot(document.getElementById('root')).render(<AppWrapper />);
})();
